import { useContext } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import { background, green, purple, white } from "../../../../../theme/colours";
import { TotalIcon } from "../../../../common/Icons";

const LeaderboardTile = ({
  isIcon,
  name,
  score,
  icon,
  isActive,
  rank,
  isUserTier,
}) => {
  const { t } = useTranslation("SafeRoads");
  const { tabletView, mobileView, desktopView } = useContext(GlobalContext);
  const theme = useTheme();

  const dotDotDotStyle = {
    textAlign: "center",
    fontSize: "1.5rem",
    fontWeight: 600,
  };
  const boxStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    mt: "0.5rem",
    background:
      isActive && `linear-gradient(93deg, ${purple[1]} 0%, ${green[1]} 100%)`,
    backgroundColor: desktopView ? background.primary : white,
    padding: "0.5rem 1.5rem 0.5rem 0.25rem",
    borderRadius: "5px",
    position: isActive && "sticky",
    bottom: isActive && "0",
  };
  const blankIconStyle = {
    ml: "1rem",
    //TEMP
    width: "3rem",
    height: "3rem",
    borderRadius: "50%",
    background: theme.palette.primary.main,
    border: `3px solid ${
      isActive ? "#B7CDFA" : mobileView ? white : "#FAF9FB"
    }`,
  };
  const placementBoxStyle = {
    display: "flex",
    mr: mobileView || tabletView ? "1rem" : "1.75rem",
    alignItems: "center",
    textAlign: "center",
  };
  const placementTextStyle = {
    width: "36px",
    color: isActive ? white : purple[1],
  };
  const textStyle = {
    lineHeight: "normal",
    fontWeight: 700,
    color: isActive && white,
  };
  const scoreTextStyle = {
    fontWeight: 700,
    ml: "0.25rem",
    lineHeight: "normal",
    fontSize: "0.875rem",
    color: isActive ? white : green[2],
  };
  const iconStyle = {
    width: mobileView || tabletView ? "25px" : "23px",
    height: "auto",
    fill: isActive ? white : green[2],
  };
  const scoreStyle = {
    display: "flex",
  };
  const nameAreaStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  };

  return (
    <>
      {isUserTier && rank > 10 && (
        <Typography sx={dotDotDotStyle}>...</Typography>
      )}
      <Box sx={boxStyle}>
        {isIcon && (
          <Box sx={placementBoxStyle}>
            {rank <= 3 ? (
              <img
                alt={t("medalDesc")}
                src={
                  rank === 1
                    ? "/images/safeRoads/FirstPlace.svg"
                    : rank === 2
                    ? "/images/safeRoads/SecondPlace.svg"
                    : "/images/safeRoads/ThirdPlace.svg"
                }
                width="36px"
              />
            ) : (
              <Typography sx={placementTextStyle} variant="h4">
                {"#" + rank}
              </Typography>
            )}
            {icon ? (
              <Box
                component="img"
                alt={`${name} ${t("teamIcon")}`}
                src={icon}
                width="3rem"
                height="3rem"
                sx={{ ml: "1rem" }}
              />
            ) : (
              <Box sx={blankIconStyle} />
            )}
          </Box>
        )}
        <Box sx={nameAreaStyle}>
          <Typography sx={textStyle} variant={tabletView ? "h2" : "h4"}>
            {name}
          </Typography>
          <Box sx={scoreStyle}>
            <TotalIcon style={iconStyle} />
            <Typography
              sx={scoreTextStyle}
              variant={mobileView || tabletView ? "h4" : "body1"}>
              {score || "-"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default LeaderboardTile;
